// import {
//   createImageElement,
//   removeElements,
// } from '@src/quince-site-common/src/trackers/providers/tracking-provider-dom-utils'

function removeElements(selector: string) {
  const elements = document.querySelectorAll(selector)
  elements.forEach(element => {
    element.remove()
  })
}

function createImageElement(attributes: Record<string, string> = {}) {
  const img = document.createElement('img')
  const finalAttributes: Record<string, string> = {
    ...attributes,
    role: 'presentation',
  }
  Object.keys(finalAttributes).forEach(key => {
    img.setAttribute(key, finalAttributes[key])
  })
  return img
}

interface InitializeImageOptions {
  id: string
  src: string
  width?: string
  height?: string
  attributes?: {
    style: string
  }
}

export function initializeImg({ id, src, width = '1', height = '1', attributes }: InitializeImageOptions) {
  if (!src) return
  removeElements(`img#${id}`)
  const pixel = createImageElement({
    id: id,
    src: src,
    width: width,
    height: height,
  })
  pixel.setAttribute('style', attributes?.style ?? '')
  document.body.appendChild(pixel)
}
